<template>
  <van-nav-bar :title="title" :left-arrow="arrow" :safe-area-inset-top="true" :fixed="true" :placeholder="true"
    :border="false" @click-left="onClickLeft" />
  <!-- <div style="height: 48px;"></div> -->
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { getUserInfo } from '@/service/user';
import beasconfig from '@/utils/beasconfig';
import gMethod from '@/utils/method';

export default {
  name: 'NavBar',
  props: {
    title: {
      type: String,
      default: '登录'
    },
    arrow: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const store = useStore().state;
    const route = useRoute();
    const router = useRouter();
    const onClickLeft = () => {
      if (route.query.noPath && route.query.noPath == "首页") {  //如果参数中带有首页就直接返回到首页
        router.push({ path: `/home` })
      } else {
        history.back(1)
      }
      context.emit("leavePage");
    };

    onMounted(() => {
      if (sessionStorage.getItem('hfColor')) {
        let hfColor = JSON.parse(sessionStorage.getItem('hfColor'));
        document.documentElement.style.setProperty("--main-bg-color", hfColor.bgColor);
        document.documentElement.style.setProperty("--main-cor-color", hfColor.fontColor);
      } else {
        getUserInfo({ type: 1 }).then(res => {   //获取皮肤信息
          let data = res.data;
          if (data) {
            Object.keys(data).map(item => {
              if (item.includes('_icon') || item.includes('login_logo')) {
                data[item] = beasconfig.baseUrlapi + data[item]
              }
            })
            localStorage.setItem("ptInfo", JSON.stringify(data));
            store.ptInfo = data;
            store.appId = data.appid;
            document.documentElement.style.setProperty("--main-bg-color", res.data.top_background);
            document.documentElement.style.setProperty("--main-cor-color", res.data.top_font_color);
            sessionStorage.setItem('hfColor', JSON.stringify({
              bgColor: res.data.top_background,
              fontColor: res.data.top_font_color
            }))
          }
        })
      }
      if(store.agentinfo && store.agentinfo.agentinfo){
        store.isXin = gMethod.interceptUrl(0, store.agentinfo.agentinfo.path);
      }
    })

    return {
      onClickLeft, props
    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .van-nav-bar--fixed {
  z-index: 999999;
}

/deep/.van-nav-bar {
  background-color: var(--main-bg-color);
  font-weight: 400 !important;
  color: #ffffff !important;


  .van-nav-bar__title {
    max-width: 80%;
    color: white;
    font-weight: 400;
  }

  .van-icon {
    color: #ffffff;
  }
}
</style>
